const BuyMeACoffee = () => {
    const buttonStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '16px 24px',
        backgroundColor: 'rgba(19, 195, 255, 0.15)',
        border: '2px solid #13C3FF',
        borderRadius: '12px',
        color: '#ffffff',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: '600',
        transition: 'all 0.3s ease',
        textDecoration: 'none',
        minWidth: '160px',
        justifyContent: 'center',
        margin: '0 auto 20px auto',
        fontFamily: 'Arial',
        boxShadow: '0 0 20px rgba(19, 195, 255, 0.3)',
        animation: 'pulse 2s infinite',
    };
    const pulseKeyframes = `
        @keyframes pulse {
            0% { box-shadow: 0 0 20px rgba(19, 195, 255, 0.3); }
            50% { box-shadow: 0 0 30px rgba(19, 195, 255, 0.6); }
            100% { box-shadow: 0 0 20px rgba(19, 195, 255, 0.3); }
        }
    `;

    return (
        <>
            <style>{pulseKeyframes}</style>
            <a
                href="https://ko-fi.com/PimvH"
                target="_blank"
                rel="noopener noreferrer"
                style={buttonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.borderColor = '#29CCFF';
                    e.currentTarget.style.backgroundColor = 'rgba(19, 195, 255, 0.1)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#13C3FF';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
            >
                <i className="bi bi-cup-hot"></i>
                Buy Me A Coffee
            </a>
        </>
    );
};

export default BuyMeACoffee;
